import React, { Fragment, useEffect, useState } from 'react';
import { Button, Dialog, DialogContent } from '@mui/material';
import axios from 'axios';
import { useFormik } from 'formik';
import { staffAdviserSchema } from '../schemas';
import BlankImage from '../assets/Blank.png'
import { useSelector } from 'react-redux';

const NewStaffAdvisers = (props)=>{
    const { staff, fetchData } = props
    const uri = useSelector(state=>state.uri)
    const [dialog, setDialog] = useState(false)
    const [error, setError] = useState('')
    const [isLoading, setIsLoading] = useState(true)
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [fileSize, setFileSize] = useState('')

    useEffect(()=>{
        console.log(staff)
    }, [])
    const {handleChange, handleBlur, handleReset, handleSubmit, errors, touched, values} = useFormik({
        initialValues: {
            fullname: '',
            photo: '',
            office: '',
            position: ''       
        },
        validationSchema: staffAdviserSchema,
        onSubmit: (values)=>{            
            setIsSubmitting(true)
            axios.put(
                `${uri}executives`,
                values
            ).then(res=>{
                setFileSize('')
                handleReset()
                setIsSubmitting(false)
                fetchData()
                setDialog(false)
            }).catch(err=>{
                setIsSubmitting(false)
                console.log(err)
            })
        }
    })
    const selectOffice = (officeName)=>{
        values.office = officeName        
        setDialog(true)
    }
    const pickPhoto = ()=>{
        document.getElementById('photo').click()
    }
    const processPhoto = (e)=>{
        let file = e.target.files[0]
        if (file.type == 'image/png' || file.type == 'image/jpg' || file.type == 'image/jpeg') {
            JSON.stringify(file.size).length >= 7 ? setFileSize(`${Math.ceil(file.size/1000000)}MB`) : setFileSize(`${Math.ceil(file.size/1000)}KB`)
            const fs = new FileReader()
            fs.readAsDataURL(file)
            fs.onload = ()=>{
                values.photo = fs.result
            }
        } else {
            alert('File format not supported')
        }
    }

    return (
        <Fragment>
            <div className=''>
                <div className='row w-100'>
                    {staff.length !== 0 && <p className='fs-5'>Patrons/Staff Advisers</p>}
                    {staff.map((each, i)=>(
                        <div key={i} className='col-lg-3 col-md-6 mb-4'>
                            <div className='card cursor-pointer' onClick={()=>selectOffice(each.office)}>
                                <img src={!each.photo ? BlankImage : each.photo} className='card-img-top' />
                                <div className='card-body border card-border rounded-4'>
                                    <p className='text-center text-white'>
                                        {!each.fullname ? 'Office Holder' : each.fullname}
                                    </p>
                                    <p className='card-text text-center fst-italic'>
                                        {each.office}
                                    </p>
                                    <p className='card-text text-center fs-7 fst-italic'>
                                        {each.position}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>                
            </div>
            {/* Upload Modal */}
            <Dialog open={dialog} maxWidth={'xs'} fullWidth={true} className='font-poppins' >
                <DialogContent>
                    <p className='fs-6 fw-bold-0'>{values.office} </p>
                    <div className='my-4'>
                        <input type='text' onChange={handleChange} onBlur={handleBlur} name='fullname' className={errors.fullname && touched.fullname ? 'is-invalid form-control' : 'form-control'} placeholder='Full Name' />
                    </div>
                    <div className='my-4'>
                        <input type='text' onChange={handleChange} onBlur={handleBlur} name='position' className={errors.position && touched.position ? 'is-invalid form-control' : 'form-control'} placeholder='e.g Dean, Faculty of Pharmacy' />
                    </div>
                    <div className='my-4'>
                        <div className='d-flex'>
                            <Button onClick={pickPhoto} className='bg-yrh text-white fw-bold font-poppins'>Photo</Button> <span className='fs-5 px-2 fw-bold-0 text-yrh'>- {fileSize}</span>
                        </div>
                        <input id='photo' type='file' className='d-none form-control' onChange={processPhoto} />
                    </div>                    
                    <Button disabled={isSubmitting} onClick={handleSubmit} className={isSubmitting ? 'fw-bold border border-yrh text-yrh rounded-0 mx-1' : 'fw-bold bg-yrh text-white rounded-0 mx-1'}>
                        {
                            isSubmitting
                            ?
                            'Please wait...'
                            :
                            'Submit'
                        }
                    </Button>
                    <Button disabled={isSubmitting} onClick={()=>setDialog(false)} className='fw-bold bg-light text-dark rounded-0 mx-1'>
                        Cancel
                    </Button>
                </DialogContent>
            </Dialog>
        </Fragment>
    )
}

export default NewStaffAdvisers